module.exports = __webpack_public_path__ + "img/dropdown.a26415b4.svg";